export default {
  masterItems: [],
  dashboardData: null,
  reportData: [],
};
